import moment, { MomentInput } from 'moment';

export const Formats = Object.freeze({
	DateOnly: 'YYYY-MM-DD',
	DateTime: 'YYYY-MM-DD HH:mm'
});

export function DateFormat(date: MomentInput, format: typeof Formats[keyof typeof Formats] = Formats.DateTime) {

	if(!date || !moment(date).isValid()) {
		return '';
	}

	return moment.utc(date).local().format(format);
}
